// $(window).resize(function() {
//     if ($(window).width() <= 768) {
//         $(".img-people").insertAfter(".product-single__form")
//     }
//     else {
//         $(".img-people").insertAfter(".below-img")
//     }
// });

// if ($(window).width() <= 768) {
//     $(".img-people").insertAfter(".product-single__form")
// }
// else {
//     $(".img-people").insertAfter(".below-img")
// }
// setTimeout(function(){ 
//     $(`a.product__thumb[data-index="0"]`).trigger("click")
// }, 500);

$(window).on('load',function() {
    $(`a.product__thumb[data-index="0"]`).trigger("click")
})
var slideno = 0
if ( $('.student-slides').length ) {
    $('.item__wrapper').slick('slickGoTo', slideno);
} 

var active = $(".product-single__variants option:selected").data("variantid")
if ($('.bundles .variant-input').length ) {
    var name = $(".product-single__variants option:selected").text()
    $(`.var-content[data-variant='${active}']`).show()
    var name = $(".product-single__variants option:selected").text().split('(')[0]
    $(".product-single__title").text(name)
}


$(".bundles .variant-input").on('change', function() {
    var active = $(".product-single__variants option:selected").data("variantid")
    $(".var-content").hide()
    $(`.var-content[data-variant='${active}']`).show()
    var name = $(".product-single__variants option:selected").text().split('(')[0]
    $(".product-single__title").text(name)
})

$('div[data-yt]').click(function() {
    var id = $(this).data('yt')
    var yt = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    $(this).html(yt)
    $(this).addClass('no-icon') 
}) 

if ( $('.student-slides').length ) {
  $('.student-slides').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    arrows: true,
    prevArrow: "<button class='slick-arrow arrow-left'><i class='fas fa fa-arrow-left'></i></button>",
    nextArrow: "<button class='slick-arrow arrow-right'><i class='fas fa fa-arrow-right'></i></button>",
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
  }); 
}

 
$('.top-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3, 
    adaptiveHeight: true,
    arrows: true,
    prevArrow: `<button class='slick-arrow arrow-left'><img src='//chinktv.com/cdn/shop/t/16/assets/arr-left.png?v=67788808879705595281635920603'></button>`,
    nextArrow: `<button class='slick-arrow arrow-right'><img src='//chinktv.com/cdn/shop/t/16/assets/arr-right.png?v=124833187379768345071635920595'></button>`,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
}); 

$('.speak-slider').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1, 
  adaptiveHeight: true,
  arrows: true,
  prevArrow: `<button class='slick-arrow arrow-left'><img src='//chinktv.com/cdn/shop/t/16/assets/arr-left.png?v=67788808879705595281635920603'></button>`,
  nextArrow: `<button class='slick-arrow arrow-right'><img src='//chinktv.com/cdn/shop/t/16/assets/arr-right.png?v=124833187379768345071635920595'></button>`,
  responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false
        }
      }
  ]
}); 


$(".var-bottom").click(function() {

    var title = $(this).data('title')

    $(`.variant-input input[value="${title}"]`).trigger('click')

});

// handle links with @href started with '#' only
$(document).on('click', 'a[href^="#"]', function(e) {
    // target element id
    var id = $(this).attr('href');

    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // top position relative to the document
    var pos = $id.offset().top;

    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
});



    /// Main search input
    $('.mobsearch .search-box input[type="text"]').bind('focusin focusout', function(e){
      $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
  });
   

  /// Live search
  var preLoadLoadGif = $('<img src="//chinktv.com/cdn/shop/t/16/assets/ajax-load.gif?11894" />');
  var searchTimeoutThrottle = 500;
  var searchTimeoutID = -1;
  var currReqObj = null;
  var $resultsBox = $('<div class="results-box" />').appendTo('.mobsearch .search-box');
  $('.mobsearch .search-box input[type="text"]').bind('keyup change', function(){
      //Only search if search string longer than 2, and it has changed
if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
          //Reset previous value
          $(this).data('oldval', $(this).val());
          
          // Kill outstanding ajax request
          if(currReqObj != null) currReqObj.abort();
          
          // Kill previous search
          clearTimeout(searchTimeoutID);
        
          var $form = $(this).closest('form');
        
          //Search term
          var term = '*' + $form.find('input[name="q"]').val() + '*';
          
          //URL for full search page
          var linkURL = $form.attr('action') + '?type=product&q=' + term;
          
          //Show loading
          $resultsBox.html('<div class="load"></div>');
          
          // Do next search (in X milliseconds)
          searchTimeoutID = setTimeout(function(){
              //Ajax hit on search page
              currReqObj = $.ajax({
                url: $form.attr('action'),
                data: {
                  type: 'product',
                  view: 'json',
                  q: term,
                },
                dataType: "json",
                success: function(data){
                      currReqObj = null;
                      if(data.results_total == 0) {
                          //No results
                          $resultsBox.html('<div class="note">'+ 'No results found' +'</div>');
                      } else {
                          //Numerous results
                          $resultsBox.empty();
                            $.each(data.results, function(index, item){
                              var xshow = 'wholesale'; //term for products we dont want to show
                              if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                                var $row = $('<a class="s-item"></a>').attr('href', item.url);
                                $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                                $row.append('<div class="d-title">'+item.title+'</div>');
                                $resultsBox.append($row);
                              }
                            });
                          $resultsBox.append('<a href="' + linkURL + '" class="note">See all</a>');
                      }
                }
              });
          }, searchTimeoutThrottle);
      } else if ($(this).val().length <= 2) {
          //Deleted text? Clear results
          $resultsBox.empty();
      }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
      //Focus, show results
      $resultsBox.fadeIn(200);
  }).bind('click', function(e){
      //Click, prevent body from receiving click event
      e.stopPropagation();
  });
  $('body').bind('click', function(){
      //Click anywhere on page, hide results
      $resultsBox.fadeOut(200);
  });

  //Search box should mimic live search string: products only, partial match
  $('.search-form, #search-form').on('submit', function(e){
    e.preventDefault();
    var term = '*' + $(this).find('input[name="q"]').val() + '*';
    var linkURL = $(this).attr('action') + '?type=product&q=' + term;
    window.location = linkURL;
  });

  // search ends